import React from "react";
import { FormText } from "reactstrap";
import { ClinicSelector as BaseClinicSelector } from "../ClinicSelector";
import { InputWrapper, serializeInput } from "./InputWrapper";

export const ClinicSelector = ({ children, input, label, meta, ...rest }) => {
  const invalid = Boolean(meta.touched && meta.error);

  return (
    <InputWrapper label={label} required={rest.required} data-testid={rest["data-testid"]}>
      <BaseClinicSelector {...input} {...rest} valid={!invalid} />

      {meta.touched && meta.error && <FormText color="danger">{meta.error}</FormText>}

      {children}
    </InputWrapper>
  );
};

export const SerializedClinicSelector = serializeInput(ClinicSelector);
